import { combineReducers } from 'redux'
import LoginSlice from './slice/LoginSlice'
import RootSnackbarSlice from './slice/RootSnackbarSlice'
import RootMessageAlertSlice from './slice/RootMessageAlertSlice'
import loadingMaskSlice from './slice/loadingMaskSlice'
const appReducer = combineReducers({
  LoginSlice,
  RootSnackbarSlice,
  RootMessageAlertSlice,
  loadingMaskSlice
})

const Reducer = (state, action) => {
  // redux持久化
  if (!state && window.sessionStorage.getItem('reducer')) state = JSON.parse(window.sessionStorage.getItem('reducer'))
  const reducer = appReducer(state, action)
  window.sessionStorage.setItem('reducer', JSON.stringify(reducer))
  return reducer
}

export default Reducer
